/**
 * Pre-ATC roof dimension verification gate.
 * Exact-handle allowlist only. Fail open if settings/JS missing.
 */
(function () {
  'use strict';

  var root = document.getElementById('cc-roof-verify');
  var settingsEl = document.getElementById('cc-roof-verify-settings');
  if (!root || !settingsEl) {
    window.CCRoofVerify = {
      requiresVerify: function () {
        return false;
      },
      open: function (opts) {
        if (opts && typeof opts.onConfirm === 'function') opts.onConfirm();
      }
    };
    return;
  }

  var cfg = {};
  try {
    cfg = JSON.parse(settingsEl.textContent || '{}');
  } catch (e) {
    cfg = {};
  }

  function parseExactHandles(str) {
    if (!str || typeof str !== 'string') return [];
    return str
      .split(',')
      .map(function (s) {
        return s.trim().toLowerCase();
      })
      .filter(Boolean);
  }

  var handles = parseExactHandles(cfg.handles || '');
  var enabled = cfg.enabled !== false;

  var dialog = root.querySelector('.cc-roof-verify__dialog');
  var confirmBtn = root.querySelector('[data-cc-roof-verify-confirm]');
  var closeEls = root.querySelectorAll('[data-cc-roof-verify-close]');
  var open = false;
  var lastFocus = null;
  var pending = null;
  var focusableSelector =
    'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';

  function requiresVerify(handle) {
    if (!enabled || !handles.length) return false;
    var h = String(handle || '')
      .trim()
      .toLowerCase();
    if (!h) return false;
    return handles.indexOf(h) !== -1;
  }

  function getFocusable() {
    return Array.prototype.slice.call(dialog.querySelectorAll(focusableSelector)).filter(function (el) {
      if (el.closest('[hidden]')) return false;
      return el.offsetParent !== null && !el.hasAttribute('disabled');
    });
  }

  function trapFocus(e) {
    if (!open || e.key !== 'Tab') return;
    var nodes = getFocusable();
    if (!nodes.length) return;
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function onKeydown(e) {
    if (!open) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      cancelGate();
      return;
    }
    trapFocus(e);
  }

  function closeModal() {
    if (!open) return;
    open = false;
    root.hidden = true;
    root.setAttribute('hidden', '');
    root.setAttribute('aria-hidden', 'true');
    root.classList.remove('cc-roof-verify--open');
    document.documentElement.classList.remove('cc-roof-verify-open');
    document.removeEventListener('keydown', onKeydown);
    if (lastFocus && typeof lastFocus.focus === 'function') {
      try {
        lastFocus.focus();
      } catch (err) {}
    }
  }

  function cancelGate() {
    var cb = pending && pending.onCancel;
    pending = null;
    closeModal();
    if (typeof cb === 'function') cb();
  }

  function confirmGate() {
    var cb = pending && pending.onConfirm;
    pending = null;
    closeModal();
    if (typeof cb === 'function') cb();
  }

  function openGate(opts) {
    opts = opts || {};
    if (!requiresVerify(opts.handle)) {
      if (typeof opts.onConfirm === 'function') opts.onConfirm();
      return;
    }
    pending = {
      onConfirm: opts.onConfirm,
      onCancel: opts.onCancel
    };
    lastFocus = document.activeElement;
    root.hidden = false;
    root.removeAttribute('hidden');
    root.setAttribute('aria-hidden', 'false');
    root.classList.add('cc-roof-verify--open');
    document.documentElement.classList.add('cc-roof-verify-open');
    open = true;
    document.addEventListener('keydown', onKeydown);
    window.setTimeout(function () {
      if (confirmBtn) confirmBtn.focus();
      else if (dialog) dialog.focus();
    }, 10);
  }

  Array.prototype.forEach.call(closeEls, function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      cancelGate();
    });
  });

  if (confirmBtn) {
    confirmBtn.addEventListener('click', function (e) {
      e.preventDefault();
      confirmGate();
    });
  }

  window.CCRoofVerify = {
    requiresVerify: requiresVerify,
    open: openGate
  };
})();
